import React from "react";
import { ChevronRight } from "@mui/icons-material";

const ListItem = ({ icon, text, iconSize, onClick, className, chevron }) => {
  return (
    <React.Fragment>
      <div
        id="ListItem"
        className={`flex justify-center pointer ${
          className || "py-2 px-3 mb-3"
        }`}
        onClick={() => onClick && onClick()}
      >
        <div className="flex-none w-14">
          {/* <img src={icon} alt={text} style={{ width: iconSize || 30 }} /> */}
          {icon}
        </div>
        <div className="flex grow font-semibold items-center ml-4 text-sm">
          {text}
        </div>
        {((typeof chevron !== "undefined" && chevron) ||
          typeof chevron === "undefined") && (
          <div className="flex flex-none items-center">
            <ChevronRight />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ListItem;
